

import React from "react";
import Footer from "../components/layout/footer/Footer";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";
import DestinosSecundariosSeleccion from "../components/destinos/destinosSecundariosSeleccion";


export default function Secundarios() {
    return (
        <Layout>
          <Navbar darkBg />
          <PageHeader
            HeaderTitle="Destino Secundario"
            Parent="Destino"
            PageTitle="Secundario"
          />
          <DestinosSecundariosSeleccion hasTitle />
          <Footer />
        </Layout>
      );
}